module.exports = __webpack_public_path__ + "img/snte-s2.6afa1b09.png";